"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PulseNotificationMessage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

require("./PulseNotificationMessage.scss");

var _CrossSmall = _interopRequireDefault(require("@react/react-spectrum/Icon/core/CrossSmall"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _CheckmarkCircle = _interopRequireDefault(require("@react/react-spectrum/Icon/CheckmarkCircle"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Tooltip = _interopRequireDefault(require("@react/react-spectrum/Tooltip"));

var _PulseUtil = _interopRequireDefault(require("../../util/PulseUtil"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MarkAsRead = _interopRequireDefault(require("../../actions/MarkAsRead"));

var _Reminders = _interopRequireDefault(require("../../actions/Reminders"));

var _store = _interopRequireDefault(require("../../store/store"));

var types = _interopRequireWildcard(require("../../store/actions/actionTypes"));

var _classnames = _interopRequireDefault(require("classnames"));

var _RemindersDropDown = _interopRequireDefault(require("./RemindersDropDown"));

var Constants = _interopRequireWildcard(require("../../constants/Constants"));

var NotificationSelectors = _interopRequireWildcard(require("../../store/reducers/NotificationReducer"));

var _adobeIntlReact = require("@adobe/adobe-intl-react");

var _metrics = _interopRequireDefault(require("@exc/runtime/metrics"));

var _IconMapper = _interopRequireDefault(require("../../service/IconMapper.js"));

/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************/

/* eslint-disable @adobe/adobe-js/jsx-a11y/no-static-element-interactions */

/* eslint-disable @adobe/adobe-js/jsx-a11y/click-events-have-key-events */

/**
 * The base component that displays the notification.
 */
var PulseNotificationMessage =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(PulseNotificationMessage, _Component);

  function PulseNotificationMessage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, PulseNotificationMessage);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(PulseNotificationMessage).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hoverStatus: false,
      showToolTip: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pushMetrics", function (isFloatingAlert, isReminder) {
      if (isFloatingAlert) {
        _this.metrics.event("flyout.floatingAlert.markAsRead.click");
      } else if (isReminder) {
        _this.metrics.event("flyout.reminder.markAsRead.click");
      } else {
        _this.metrics.event("flyout.notifications.markAsRead.click");
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderCrossButton", function () {
      var _this$props = _this.props,
          pulseMessageObject = _this$props.pulseMessageObject,
          isReminder = _this$props.isReminder,
          isFloatingAlert = _this$props.isFloatingAlert;
      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        delayShow: 2000,
        offset: 10
      }, _react.default.createElement("div", null, _react.default.createElement(_Button.default, {
        label: null,
        quiet: true,
        variant: "action",
        onClick: function onClick(event) {
          event.preventDefault();

          if (isReminder) {
            _this.metrics.event("flyout.reminder.closed");

            _store.default.dispatch({
              type: types.MARK_REMINDER_AS_SHOWN,
              ids: [pulseMessageObject.id]
            });
          }

          if (isFloatingAlert) {
            _store.default.dispatch({
              type: types.MARK_NOTIFICATIONS_AS_SHOWN,
              ids: [pulseMessageObject.id]
            });

            _this.props.onMessageCloseClicked();
          }
        },
        icon: _react.default.createElement(_CrossSmall.default, {
          size: "XS"
        })
      })), _react.default.createElement(_Tooltip.default, null, isReminder ? _this.props.formatMessage({
        messageId: 'DismissReminder',
        defaultMessage: _this.props.localeData['en-US'].DismissReminder,
        description: "Dismiss Reminder"
      }) : _this.props.formatMessage({
        messageId: 'DismissAlert',
        defaultMessage: _this.props.localeData['en-US'].DismissAlert,
        description: "Dismiss"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderTimeAgo", function () {
      var pulseMessageObject = _this.props.pulseMessageObject;
      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        delayShow: Constants.TOOLTIP_DELAY_ON_TIME_AGO
      }, _react.default.createElement("div", {
        className: "pulse-notification-message-time-ago"
      }, _PulseUtil.default.formatTimeAgo(pulseMessageObject.createdTimestamp, true)), _react.default.createElement(_Tooltip.default, null, _PulseUtil.default.formatDate(pulseMessageObject.createdTimestamp)));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderActions", function () {
      return _react.default.createElement("div", {
        className: "pulse-notification-message-row3"
      }, _react.default.createElement("div", {
        className: "pulse-notification-message-action-buttons-right"
      }, _react.default.createElement(_Button.default, {
        className: "pulse-notification-message-reject-button",
        variant: "primary",
        quiet: true
      }, _this.props.formatMessage({
        messageId: 'Reject',
        defaultMessage: _this.props.localeData['en-US'].Reject,
        description: "Reject"
      })), _react.default.createElement(_Button.default, {
        className: "pulse-notification-message-approve-button",
        variant: "primary",
        quiet: true
      }, _this.props.formatMessage({
        messageId: 'Approve',
        defaultMessage: _this.props.localeData['en-US'].Approve,
        description: "Approve"
      }))));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderPriorityTag", function () {
      return _react.default.createElement("div", {
        className: "pulse-notification-message-priority-tag"
      }, _this.props.formatMessage({
        messageId: 'High',
        defaultMessage: _this.props.localeData['en-US'].High,
        description: "High"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderMarkAsRead", function () {
      var _this$props2 = _this.props,
          pulseMessageObject = _this$props2.pulseMessageObject,
          isFloatingAlert = _this$props2.isFloatingAlert,
          isReminder = _this$props2.isReminder,
          formatMessage = _this$props2.formatMessage;
      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        delayShow: 100
      }, _react.default.createElement("div", {
        className: "pulse-notification-message-actions-button"
      }, _react.default.createElement(_Button.default, {
        label: null,
        quiet: true,
        className: "notification-mark-as-read-button",
        variant: "action",
        onClick: function onClick(event) {
          event.preventDefault();
          event.stopPropagation();

          _this.pushMetrics(isFloatingAlert, isReminder);

          new _MarkAsRead.default().performAction(pulseMessageObject.id);

          if (isReminder) {
            _store.default.dispatch({
              type: types.MARK_REMINDER_AS_SHOWN,
              ids: [pulseMessageObject.id]
            });
          }
        },
        icon: _react.default.createElement(_CheckmarkCircle.default, {
          size: "S"
        })
      })), _react.default.createElement(_Tooltip.default, null, pulseMessageObject.isRead ? _this.props.formatMessage({
        messageId: 'markAsUnead',
        defaultMessage: _this.props.localeData['en-US'].markAsUnread,
        description: "Mark as Unread"
      }) : _this.props.formatMessage({
        messageId: 'markAsRead',
        defaultMessage: _this.props.localeData['en-US'].markAsRead,
        description: "Mark as read"
      })));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderSnoozeButton", function () {
      var _this$props3 = _this.props,
          pulseMessageObject = _this$props3.pulseMessageObject,
          isReminder = _this$props3.isReminder;
      var isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > NotificationSelectors.getServerTime(_store.default.getState());
      return _react.default.createElement(_RemindersDropDown.default, {
        onReminderSelected: function onReminderSelected(futureTime) {
          _Reminders.default.setReminder(pulseMessageObject.id, futureTime);

          _this.metrics.event("notification.reminder.set");

          if (isReminder) {
            //push metrics for setting `reminder` on existing displayed reminders
            _this.metrics.event("notification.reminder.onReminder.set");

            _store.default.dispatch({
              type: types.MARK_REMINDER_AS_SHOWN,
              ids: [pulseMessageObject.id]
            });
          }
        },
        onReminderDeleted:
        /*#__PURE__*/
        (0, _asyncToGenerator2.default)(
        /*#__PURE__*/
        _regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _Reminders.default.removeReminders([pulseMessageObject]);

                case 2:
                  if (isReminder) {
                    _store.default.dispatch({
                      type: types.MARK_REMINDER_AS_SHOWN,
                      ids: [pulseMessageObject.id]
                    });
                  }

                case 3:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        })),
        isReminderActive: isReminderActive,
        reminderTime: pulseMessageObject.reminderTime,
        onReminderDropDownOpen: function onReminderDropDownOpen() {
          _this.setState({
            isReminderDropDownOpen: true
          });
        },
        onReminderDropDownClose: function onReminderDropDownClose() {
          _this.setState({
            isReminderDropDownOpen: false
          });
        },
        locale: _this.props.locale
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFloatingActions", function () {
      var _this$state = _this.state,
          hoverStatus = _this$state.hoverStatus,
          isReminderDropDownOpen = _this$state.isReminderDropDownOpen;
      var style = 'pulse-notification-message-actions-bar';

      if (hoverStatus || isReminderDropDownOpen) {
        return _react.default.createElement("div", {
          className: style
        }, _this.renderTimeAgo(), _this.renderSnoozeButton(), _this.renderCrossButton());
      }

      return _react.default.createElement("div", {
        className: style
      }, _this.renderTimeAgo());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderFlyoutActions", function () {
      var _this$state2 = _this.state,
          hoverStatus = _this$state2.hoverStatus,
          isReminderDropDownOpen = _this$state2.isReminderDropDownOpen;
      var pulseMessageObject = _this.props.pulseMessageObject;
      var style = 'pulse-notification-message-actions-bar';
      var isReminderActive = pulseMessageObject.reminderTime && pulseMessageObject.reminderTime > NotificationSelectors.getServerTime(_store.default.getState());

      if (hoverStatus || isReminderDropDownOpen) {
        return _react.default.createElement("div", {
          className: style
        }, _this.renderTimeAgo(), !pulseMessageObject.fromReminder && _this.renderMarkAsRead(), _this.renderSnoozeButton());
      }

      return _react.default.createElement("div", {
        className: style
      }, _this.renderTimeAgo(), isReminderActive && _this.renderSnoozeButton());
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "renderAvatar", function () {
      var pulseMessageObject = _this.props.pulseMessageObject;
      var defaultUserAvatar = 'https://a5.behance.net/9d69c04b1bfd0b34d764752cc130650d869b29d8/img/profile/no-image-50.png?cb=264615658';
      return _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "top",
        offset: 10,
        delayShow: Constants.TOOLTIP_DELAY_ON_AVATAR
      }, _react.default.createElement("div", null, pulseMessageObject.isUser ? _react.default.createElement("img", {
        src: pulseMessageObject.avatar ? pulseMessageObject.avatar : defaultUserAvatar,
        alt: "avatar",
        className: "pulse-notification-message-avatar"
      }) : _react.default.createElement(_IconMapper.default, {
        product: pulseMessageObject.avatar ? pulseMessageObject.avatar.longName : 'Experience Cloud'
      })), _react.default.createElement(_Tooltip.default, {
        className: "avatar-tooltip-label"
      }, pulseMessageObject.isUser ? "".concat(pulseMessageObject.firstName, " ").concat(pulseMessageObject.lastName) : pulseMessageObject.product));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onNotificationClick", function () {
      var _this$props4 = _this.props,
          pulseMessageObject = _this$props4.pulseMessageObject,
          isReminder = _this$props4.isReminder;

      _this.metrics.event("notification.navigationLink.click");

      var validUrl = _PulseUtil.default.validateUrl(pulseMessageObject.url);

      _store.default.dispatch({
        type: types.NOTIFICATION_URL_LINK_VALIDATION,
        payload: validUrl
      });

      !validUrl && setTimeout(function () {
        return _store.default.dispatch({
          type: types.NOTIFICATION_URL_LINK_VALIDATION,
          payload: !validUrl
        });
      }, 3000);
      isReminder && _store.default.dispatch({
        type: types.MARK_REMINDER_AS_SHOWN,
        ids: [pulseMessageObject.id]
      });

      if (!pulseMessageObject.isRead || pulseMessageObject.fromReminder) {
        new _MarkAsRead.default().performAction(pulseMessageObject.id);

        _store.default.dispatch({
          type: types.MARK_NOTIFICATION_AS_READ,
          payload: {
            id: pulseMessageObject.id
          }
        });
      }
    });
    _this.metrics = _metrics.default.create("exc.pulse.components.message.PulseNotificationMessage");
    _this.textRef = _react.default.createRef();
    return _this;
  }

  (0, _createClass2.default)(PulseNotificationMessage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.textRef.current) {
        var isTextOverflow = this.textRef.current.offsetHeight < this.textRef.current.scrollHeight;
        this.setState({
          showToolTip: isTextOverflow
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          pulseMessageObject = _this$props5.pulseMessageObject,
          isFloatingAlert = _this$props5.isFloatingAlert,
          renderCrossButton = _this$props5.renderCrossButton,
          formatMessage = _this$props5.formatMessage,
          locale = _this$props5.locale;
      var backgroundStyle = pulseMessageObject.isRead || isFloatingAlert ? 'pulse-notification-read-background' : 'pulse-notification-unread-background';
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('pulse-notification-message-root', backgroundStyle),
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            hoverStatus: true
          });
        },
        onMouseMove: function onMouseMove() {
          return _this2.setState({
            hoverStatus: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            hoverStatus: false
          });
        }
      }, _react.default.createElement("a", (0, _extends2.default)({
        style: {
          textDecoration: "none",
          color: "inherit"
        },
        onClick: function onClick(event) {
          _this2.onNotificationClick();
        }
      }, _PulseUtil.default.validateUrl(pulseMessageObject.url) && {
        href: pulseMessageObject.url
      }, _PulseUtil.default.validateUrl(pulseMessageObject.url) && {
        target: "_blank"
      }), _react.default.createElement("div", {
        className: "pulse-notification-message-row1"
      }, pulseMessageObject.priority === 'high' ? this.renderPriorityTag() : null, _react.default.createElement("div", {
        className: "pulse-notification-message-product-name"
      }, ' ', pulseMessageObject.product), isFloatingAlert || renderCrossButton ? this.renderFloatingActions() : this.renderFlyoutActions()), _react.default.createElement("div", {
        className: "pulse-notification-message-row2"
      }, _react.default.createElement("div", {
        className: "pulse-notification-message-row2-col1"
      }, this.renderAvatar()), _react.default.createElement(_OverlayTrigger.default, {
        trigger: "hover",
        placement: "right"
      }, _react.default.createElement("div", {
        ref: this.textRef,
        className: "pulse-notification-message-row2-col2"
      }, _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: pulseMessageObject.text
        }
      })), _react.default.createElement(_Tooltip.default, {
        style: this.state.showToolTip ? {
          visibility: "visible"
        } : {
          visibility: "hidden"
        }
      }, " ", _react.default.createElement("div", {
        dangerouslySetInnerHTML: {
          __html: pulseMessageObject.text
        }
      })))), pulseMessageObject.isActionable ? this.renderActions() : null));
    }
  }]);
  return PulseNotificationMessage;
}(_react.Component);

exports.PulseNotificationMessage = PulseNotificationMessage;
(0, _defineProperty2.default)(PulseNotificationMessage, "propTypes", {
  isFloatingAlert: _propTypes.default.bool,
  onMessageCloseClicked: _propTypes.default.func,
  pulseMessageObject: _propTypes.default.shape().isRequired
});
(0, _defineProperty2.default)(PulseNotificationMessage, "defaultProps", {
  isFloatingAlert: false,
  onMessageCloseClicked: function onMessageCloseClicked() {}
});

var _default = (0, _adobeIntlReact.withLocalization)(PulseNotificationMessage);

exports.default = _default;